import React, { useContext, useEffect, useMemo, useState } from 'react';
import { AdsOfficeDto } from '../../dto/adsOffice';
import { getAllAdsOfficeByLangApi } from '../../api/adsOffice';
import { useTranslation } from 'react-i18next';
import { PagePrincipal } from '../../containers';
import { isEmpty, orderBy, uniq } from 'lodash';
import Filter from './filtres';
import { ISearchFiltres } from './types';
import { isAfter, isBefore } from 'date-fns';
import { Pagination } from '../../components';
import { getDatePagination } from '../../utilitys/pagination';
import Panel from './panel';
import contextApp from '../../hooks/contexts/contextApp';
import { EnumModules } from '../../constants/Modules';
const RECORDS_PER_PAGE = 5;
const APP_KEY_FEATURE = 'ads';

const AdsOffice = () => {
  const { i18n, t } = useTranslation();
  const ctxApp = useContext(contextApp);
  const [normative, setAds] = useState<AdsOfficeDto[]>([]);
  const [adsFilter, setAdsFilted] = useState<
    AdsOfficeDto[]
  >([]);
  const [page, setPage] = useState<number>(1);
  const [adsToShow, setAdsToShow] = useState<
    AdsOfficeDto[]
  >([]);

  useEffect(() => {
    const fetch = async () => {
      const result = await getAllAdsOfficeByLangApi();
      const orderedResult = orderBy(result, (p) => p.title);
      setAds(orderedResult);
      setAdsFilted(orderedResult);
      const paginatedData = getDatePagination(
        orderedResult,
        1,
        RECORDS_PER_PAGE
      );
      setAdsToShow(paginatedData);
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  const onFiter = (filtres: ISearchFiltres) => {
    let listFiltred: AdsOfficeDto[] = [...normative];
    if (filtres.title)
      listFiltred = listFiltred.filter((p) =>
        p.title.toLowerCase().includes(filtres.title!.toLowerCase())
      );

    if (!isEmpty(filtres.types))
      listFiltred = listFiltred.filter((p) => filtres.types!.includes(p.type));

    if (filtres.description) {
      listFiltred = listFiltred.filter(
        (p) =>
          p.paragraph1
            ?.toLowerCase()
            .includes(filtres.description!.toLowerCase()) ||
          p.paragraph2
            ?.toLowerCase()
            .includes(filtres.description!.toLowerCase()) ||
          p.paragraph3
            ?.toLowerCase()
            .includes(filtres.description!.toLowerCase()) ||
          p.paragraph4
            ?.toLowerCase()
            .includes(filtres.description!.toLowerCase())
      );
    }

    if (filtres.expeditionDateEnd && filtres.expeditionDateStart) {
      listFiltred = listFiltred.filter(
        (p) =>
          isAfter(new Date(p.expeditionDate), filtres.expeditionDateStart!) &&
          isBefore(new Date(p.expeditionDate), filtres.expeditionDateEnd!)
      );
    }
    if (filtres.publicationDateStart && filtres.publicationDateEnd) {
      listFiltred = listFiltred.filter(
        (p) =>
          isAfter(new Date(p.publicationDate), filtres.publicationDateStart!) &&
          isBefore(new Date(p.publicationDate), filtres.publicationDateEnd!)
      );
    }

    setPage(1);
    setAdsFilted(listFiltred);
    const paginatedData = getDatePagination(listFiltred, 1, RECORDS_PER_PAGE);
    setAdsToShow(paginatedData);
  };

  const getTypes = useMemo(
    () => uniq(normative.map((p) => p.type)),
    [normative]
  );

  const changePage = (newPage: number) => {
    const paginatedData = getDatePagination(
      adsFilter,
      newPage,
      RECORDS_PER_PAGE
    );
    setPage(newPage);
    setAdsToShow(paginatedData);
  };

  const menuOption = ctxApp.menuOptions?.find((option) => option.code.toLowerCase() === EnumModules.ADS.toLowerCase());

  return (
    <PagePrincipal title={menuOption?.value || t('pages.adsOffice.title')}>
      <div className='flex flex-col sm:items-center md:items-start space-y-5 md:flex-row p-0 space-x-5 lg:space-y-5'>
        <div className='w-full max-w-sm'>
          <Filter types={getTypes} onFiter={onFiter} />
        </div>
        <div className='w-full h-full'>
          <Panel ads={adsToShow} />
          <div className='flex justify-center pt-5'>
            <Pagination
              recordsPerPage={RECORDS_PER_PAGE}
              total={adsFilter.length}
              page={page}
              onChangePage={changePage}
            />
          </div>
        </div>
      </div>
    </PagePrincipal>
  );
};
export default AdsOffice;
